/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetApiV3MetricsAverageLastRewardEventFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3MetricsAverageLastRewardEventFormat = ClosedEnum<
  typeof GetApiV3MetricsAverageLastRewardEventFormat
>;

export type GetApiV3MetricsAverageLastRewardEventRequest = {
  /**
   * End Timestamp
   */
  end?: number | null | undefined;
  format?: GetApiV3MetricsAverageLastRewardEventFormat | undefined;
  /**
   * Start Timestamp
   */
  start?: number | null | undefined;
  /**
   * Float Step value
   */
  step?: number | undefined;
};

/** @internal */
export const GetApiV3MetricsAverageLastRewardEventFormat$inboundSchema:
  z.ZodNativeEnum<typeof GetApiV3MetricsAverageLastRewardEventFormat> = z
    .nativeEnum(GetApiV3MetricsAverageLastRewardEventFormat);

/** @internal */
export const GetApiV3MetricsAverageLastRewardEventFormat$outboundSchema:
  z.ZodNativeEnum<typeof GetApiV3MetricsAverageLastRewardEventFormat> =
    GetApiV3MetricsAverageLastRewardEventFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsAverageLastRewardEventFormat$ {
  /** @deprecated use `GetApiV3MetricsAverageLastRewardEventFormat$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsAverageLastRewardEventFormat$inboundSchema;
  /** @deprecated use `GetApiV3MetricsAverageLastRewardEventFormat$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsAverageLastRewardEventFormat$outboundSchema;
}

/** @internal */
export const GetApiV3MetricsAverageLastRewardEventRequest$inboundSchema:
  z.ZodType<
    GetApiV3MetricsAverageLastRewardEventRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    end: z.nullable(z.number()).default(null),
    format: GetApiV3MetricsAverageLastRewardEventFormat$inboundSchema.default(
      "json",
    ),
    start: z.nullable(z.number()).default(null),
    step: z.number().default(7200),
  });

/** @internal */
export type GetApiV3MetricsAverageLastRewardEventRequest$Outbound = {
  end: number | null;
  format: string;
  start: number | null;
  step: number;
};

/** @internal */
export const GetApiV3MetricsAverageLastRewardEventRequest$outboundSchema:
  z.ZodType<
    GetApiV3MetricsAverageLastRewardEventRequest$Outbound,
    z.ZodTypeDef,
    GetApiV3MetricsAverageLastRewardEventRequest
  > = z.object({
    end: z.nullable(z.number()).default(null),
    format: GetApiV3MetricsAverageLastRewardEventFormat$outboundSchema.default(
      "json",
    ),
    start: z.nullable(z.number()).default(null),
    step: z.number().default(7200),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsAverageLastRewardEventRequest$ {
  /** @deprecated use `GetApiV3MetricsAverageLastRewardEventRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsAverageLastRewardEventRequest$inboundSchema;
  /** @deprecated use `GetApiV3MetricsAverageLastRewardEventRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsAverageLastRewardEventRequest$outboundSchema;
  /** @deprecated use `GetApiV3MetricsAverageLastRewardEventRequest$Outbound` instead. */
  export type Outbound = GetApiV3MetricsAverageLastRewardEventRequest$Outbound;
}

export function getApiV3MetricsAverageLastRewardEventRequestToJSON(
  getApiV3MetricsAverageLastRewardEventRequest:
    GetApiV3MetricsAverageLastRewardEventRequest,
): string {
  return JSON.stringify(
    GetApiV3MetricsAverageLastRewardEventRequest$outboundSchema.parse(
      getApiV3MetricsAverageLastRewardEventRequest,
    ),
  );
}

export function getApiV3MetricsAverageLastRewardEventRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3MetricsAverageLastRewardEventRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3MetricsAverageLastRewardEventRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiV3MetricsAverageLastRewardEventRequest' from JSON`,
  );
}
